import React from 'react';
import { useDispatch } from 'react-redux';

import Segmented, { SegmentedOption } from 'components/DesignSystem/Segmented';
import DownloadButton from 'components/Meteorology/Fields/ImageDownloadButton';
import useComparatorControlPanel from 'utils/hooks/meteorology/comparator/useComparatorControlPanel';
import {
  PeriodOptions,
  setTriggerActivity,
} from 'redux/reducers/meteorologyFieldsComparatorControlPanelReducer';

import './index.scss';

type Period = Exclude<PeriodOptions, undefined>;

const PERIODS: SegmentedOption<Period>[] = [
  { value: 'd', label: 'D' },
  { value: 'p', label: 'P' },
  { value: 's', label: 'S' },
  { value: 'm', label: 'M' },
  { value: 't', label: 'T' },
];

export default function PeriodPills({
  onDownloadClick,
  downloadDisabled,
}: {
  onDownloadClick: () => void;
  downloadDisabled: boolean;
}) {
  const dispatch = useDispatch();
  const { period, setComparativePeriod } = useComparatorControlPanel();

  const selectPeriod = (value: Period) => {
    setComparativePeriod(value);
    dispatch(setTriggerActivity(true));
  };

  return (
    <div className="comparator-period-pills">
      <Segmented
        size="sm"
        fill={false}
        options={PERIODS}
        value={period as Period}
        onChange={selectPeriod}
      />
      <DownloadButton onClick={onDownloadClick} disabled={downloadDisabled} />
    </div>
  );
}
